/**
 * Zdielany vzhlad "chip" tlacidiel naprie filtrom (typy nehnutelnosti,
 * cenove presety, prepinace novostavby/video/3D).
 *
 * Rovnaky vzor ako motion.ts - exportovane class-name konstanty, aby sa
 * rovnaky prvok nekopiroval do viacerych suborov.
 */
export const CHIP_BASE =
    'text-[12px] font-[500] py-[7px] px-[12px] rounded-full cursor-pointer whitespace-nowrap transition duration-200 ease-[var(--ease-rx)] active:scale-[.97]';

/** Vybrany stav - plna brand zlta #F3C300 s jemnym glow (svetla #f8ebb4 ostava len pre hover a badge). */
export const CHIP_ON = 'bg-[#F3C300] text-black shadow-[0_2px_10px_rgba(243,195,0,.35)]';

/** Nevybrany stav. */
export const CHIP_OFF = 'bg-[#f6f5f0] text-black/75 hover:bg-[#f8ebb4] hover:text-black';

/** Tichy chip (reset / "bez limitu") - bez vyplne, kym nie je hover. */
export const CHIP_QUIET = 'bg-transparent text-black/55 hover:bg-[#f6f5f0] hover:text-black';
